import React, { useReducer, useState, useEffect } from "react";
import Button from "./Button";
import Container from "./Container";
import Searchbar from "./Searchbar";
import Table1 from "./Table1";
import { reducer, initialState } from "../reducers/reducers";
import Dropdown from "./Dropdown";
import API_URLS from "../Urls";
import EditInventoryQuantity from "./EditInventoryQuantity";

const Inventory = () => {
  const [selectedOption, setSelectedOption] = useState('Servicios');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [editItem, setEditItem] = useState();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [searchText, setSearchText] = useState("");

  // Paginación
  const [page, setPage] = useState(1);
  const [perPage] = useState(30);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Efecto: actualizar paginación cuando cambian los datos filtrados
  useEffect(() => {
    setTotalItems(filteredData.length);
    setLastPage(Math.ceil(filteredData.length / perPage) || 1);
    setPage(1);
  }, [filteredData, perPage]);

  // Obtener datos base y detalle de inventario
  const fetchData = (url, onSuccesful) => {
    fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
      })
      .then(data => {
        if (typeof onSuccesful === 'function') onSuccesful(data);
      })
      .catch(error => console.error('Fetch error:', error));
  };

  const requestData = () => {
    let url = "";
    let tipo = "";

    switch (selectedOption) {
      case 'Dron Enterprise':
        url = API_URLS.DRONES;
        tipo = 'Dron Enterprise';
        break;
      case 'Dron Comercial':
        url = API_URLS.DRONES;
        tipo = 'Dron Comercial';
        break;
      case 'Accesorios':
        url = API_URLS.ACCESORIES;
        tipo = 'Accesorio';
        break;
      case 'Partes':
        url = API_URLS.PARTS;
        tipo = 'Parte';
        break;
      default:
        return;
    }

    fetchData(url, (baseData) => {
      console.log(baseData)
      const promises = baseData.map(item => new Promise(resolve => {
        fetchData(
          `${API_URLS.INVENTORY}?id_producto=${item.id}&tipo_producto=${tipo}`,
          (detailData) => {
            const { tipo: _, ...itemInfo } = item;
            if (!detailData || detailData.length === 0) {
              return resolve({
                ...itemInfo,
                cantidad: 'No especificado',
                actualizacion_hecha_por: 'N/A',
                ultima_actualizacion: 'N/A',
                objecttype: item.tipo
              });
            }
            resolve({
              id_inventario: detailData[0].id,
              ...detailData[0],
              ...itemInfo,
              objecttype: item.tipo
            });
          }
        );
      }));

      Promise.all(promises)
        .then(results => {
          setData(results);
        })
        .catch(error => console.error('Enrich error:', error));
    });
  };

  // Efecto: obtener datos al cambiar de tipo
  useEffect(() => {
    requestData();
  }, [selectedOption]);

  // Efecto: sincronizar datos filtrados con datos originales
  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  // Búsqueda
  const handleSearch = () => {
    if (!searchText) {
      setFilteredData(data);
      setPage(1);
      return;
    }
    let filtered = [];
    switch (selectedOption) {
      case 'Dron Enterprise':
        filtered = data.filter(item =>
          item.linea === 'Enterprise' && (
            item.serie?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.modelo?.toLowerCase().includes(searchText.toLowerCase())
          )
        );
        break;
      case 'Dron Comercial':
        filtered = data.filter(item =>
          item.linea === 'Comercial' && (
            item.serie?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.modelo?.toLowerCase().includes(searchText.toLowerCase())
          )
        );
        break;
      case 'Accesorios':
        filtered = data.filter(item =>
          item.tipo?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.modelo?.toLowerCase().includes(searchText.toLowerCase())
        );
        break;
      case 'Partes':
        filtered = data.filter(item =>
          item.modelo?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.tipo?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.no_serie?.toLowerCase().includes(searchText.toLowerCase())
        );
        break;
      default:
        filtered = data;
    }
    setFilteredData(filtered);
    setPage(1);
  };

  // Datos de la página actual
  const paginatedData = filteredData.slice((page - 1) * perPage, page * perPage);

  // Controles de paginación
  function PaginationControls() {
    const buttonStyle = {
      backgroundColor: '#7AACE3',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      padding: '8px 16px',
      margin: '0 5px',
      cursor: 'pointer',
      fontWeight: 'bold',
      transition: 'background-color 0.3s'
    };
    const disabledStyle = { ...buttonStyle, backgroundColor: '#cccccc', cursor: 'not-allowed', opacity: 0.7 };

    return (
      <div style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
        <button onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={page === 1} style={page === 1 ? disabledStyle : buttonStyle}>
          &lt; Anterior
        </button>
        <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
          Página {page} de {lastPage} ({totalItems} items)
        </span>
        <button onClick={() => setPage(p => Math.min(p + 1, lastPage))} disabled={page === lastPage} style={page === lastPage ? disabledStyle : buttonStyle}>
          Siguiente &gt;
        </button>
      </div>
    );
  }

  // Renderizado de tabla según tipo
  function renderTable(dataToRender) {
    // ... (igual que antes, pero usando dataToRender en lugar de data)
    console.log(dataToRender)
    switch(selectedOption){
      case 'Dron Enterprise':
        return (
        <Table1
          headers={['Id','Serie','Modelo','Cantidad','Ultima actualizacion','Actualizado por:']}
          optedit
          onClickEdit={d => {
            dispatch({ type: 'openEditQuantity' });
            const method = d[3] === 'No especificado' ? 'POST' : 'PUT';
            setEditItem({ ...data.find(item => item.id === d[0]), tipo: 'Dron Enterprise', method });
          }}
          data={dataToRender.filter(item=>item.linea == 'Enterprise').map(item => [item.id, item.serie, item.modelo, item.cantidad, item.ultima_actualizacion, item.actualizacion_hecha_por])}
        />
      );
      break;
      case 'Dron Comercial':
        return (
        <Table1
          headers={['Id','Serie','Modelo','Cantidad','Ultima actualizacion','Actualizado por:']}
          optedit
          onClickEdit={d => {
            dispatch({ type: 'openEditQuantity' });
            const method = d[3] === 'No especificado' ? 'POST' : 'PUT';
            setEditItem({ ...data.find(item => item.id === d[0]), tipo: 'Dron Comercial', method });
          }}
          data={dataToRender.filter(item=>item.linea == 'Comercial').map(item => [item.id, item.serie, item.modelo, item.cantidad, item.ultima_actualizacion, item.actualizacion_hecha_por])}
        />
      );
      break;
      case 'Accesorios':
        return (
        <Table1
          headers={['Id','Tipo','Modelo','Cantidad','Ultima actualizacion','Actualizado por:']}
          optedit
          onClickEdit={d => {
            dispatch({ type: 'openEditQuantity' });
            const method = d[3] === 'No especificado' ? 'POST' : 'PUT';
            setEditItem({ ...data.find(item => item.id === d[0]), tipo: 'Accesorio', method });
          }}
          data={dataToRender.map(item => [item.id, item.objecttype, item.modelo, item.cantidad, item.ultima_actualizacion, item.actualizacion_hecha_por])}
        />
      );
      break;
      case 'Partes':
        return (
        <Table1
          headers={['Id','Tipo','Modelo','Cantidad','Ultima actualizacion','Actualizado por:']}
          optedit
          onClickEdit={d => {
            dispatch({ type: 'openEditQuantity' });
            const method = d[3] === 'No especificado' ? 'POST' : 'PUT';
            setEditItem({ ...data.find(item => item.id === d[0]), tipo: 'Parte', method });
          }}
          data={dataToRender.map(item => [item.id, item.objecttype, item.modelo, item.cantidad, item.ultima_actualizacion, item.actualizacion_hecha_por])}
        />
      );
      break;
    }
      
    }
    // ... Repetir para los demás casos ('Dron Comercial', 'Accesorios', 'Partes') usando dataToRender
  

  return (
    <div className="anylayout">
      <div className="titleFont">Inventario</div>
      <Container>
        <div>Tipo:</div>
        <Dropdown returnSelectedOption={setSelectedOption} options={['Dron Enterprise','Dron Comercial','Accesorios','Partes']} />
        <Searchbar text="Buscar..." value={searchText} onChange={setSearchText} />
        <Button text="🔎" color="#7AACE3" onClick={handleSearch} />
      </Container>

      <PaginationControls />
      {renderTable(paginatedData)}
      <PaginationControls />

      {state.statusEditQuantity && (
        <EditInventoryQuantity
          item={editItem}
          onAccept={() => { dispatch({ type: 'closeEditQuantity' }); requestData(); }}
          onCancel={() => dispatch({ type: 'closeEditQuantity' })}
        />
      )}
    </div>
  );
};

export default Inventory;
